import { canonicalCategoryName } from "./productCategories";

export const SALESBEEZ_ORIGIN = "https://salesbeez.in";
export const SALESBEEZ_CATEGORIES_API = `${SALESBEEZ_ORIGIN}/api/categories?limit=500`;

/**
 * Our catalog name → Salesbeez category name(s), first match with an image wins.
 */
export const SALESBEEZ_CATEGORY_ALIASES = {
  Electronics: ["electronics"],
  "Food & Beverages": [
    "grocery",
    "beverages",
    "packaged foods",
    "staples & grains",
    "dry fruits, nuts & seeds",
    "bakery",
    "dairy products",
  ],
  "Health & Beauty": ["beauty and cosmetics", "health & wellness"],
  "Baby & Kids": ["babycare"],
  "Pet Supplies": ["pet care"],
  "Office Supplies": ["stationery"],
  "Books & Media": ["stationery"],
  "Personal Care": ["personal care"],
  "Home & Garden": ["home & kitchen", "home care & cleaning"],
  "Kitchen & Dining": ["home & kitchen", "grocery"],
  Furniture: ["home & kitchen"],
  "Arts & Crafts": ["puja & spiritual"],
};

/** Fallback URLs (from Salesbeez API) if fetch fails */
export const SALESBEEZ_STATIC_IMAGE_BY_CATEGORY = {
  Electronics: `${SALESBEEZ_ORIGIN}/api/uploads/files/1785991943232-560xsnd1sp9.png`,
  "Food & Beverages": `${SALESBEEZ_ORIGIN}/api/uploads/files/1785759135642-yraa46delv.png`,
  "Health & Beauty": `${SALESBEEZ_ORIGIN}/api/uploads/files/1784633910993-gs2pkvqsga5.png`,
  "Baby & Kids": `${SALESBEEZ_ORIGIN}/api/uploads/files/1786449490386-u31mdgq5pra.png`,
  "Pet Supplies": `${SALESBEEZ_ORIGIN}/api/uploads/files/1786449531035-pzkfdjfhjq.png`,
  "Office Supplies": `${SALESBEEZ_ORIGIN}/api/uploads/files/1786449543871-e68fc7fg306.png`,
  "Books & Media": `${SALESBEEZ_ORIGIN}/api/uploads/files/1786449543871-e68fc7fg306.png`,
  "Personal Care": `${SALESBEEZ_ORIGIN}/api/uploads/files/1787642453228-g8sh8lu1d3f.png`,
  "Home & Garden": `${SALESBEEZ_ORIGIN}/api/uploads/files/1787649981729-o0v5bxxli8.png`,
  "Kitchen & Dining": `${SALESBEEZ_ORIGIN}/api/uploads/files/1787649981729-o0v5bxxli8.png`,
  Furniture: `${SALESBEEZ_ORIGIN}/api/uploads/files/1787649981729-o0v5bxxli8.png`,
  "Arts & Crafts": `${SALESBEEZ_ORIGIN}/api/uploads/files/1786449503626-gb5whzi4g79.png`,
};

const normalizeName = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

export function toSalesbeezImageUrl(imageUrl) {
  if (!imageUrl) return null;
  if (imageUrl.startsWith("http")) return imageUrl;
  return `${SALESBEEZ_ORIGIN}${imageUrl.startsWith("/") ? "" : "/"}${imageUrl}`;
}

/**
 * Build map: our category name → full Salesbeez image URL
 */
export function buildSalesbeezImageMap(apiCategories = []) {
  const withImages = apiCategories.filter((c) => c?.isActive !== false && c?.imageUrl);
  const byNormalizedName = new Map();
  withImages.forEach((c) => {
    byNormalizedName.set(normalizeName(c.name), c);
  });

  const result = {};

  Object.entries(SALESBEEZ_CATEGORY_ALIASES).forEach(([ourName, aliases]) => {
    for (const alias of aliases) {
      const hit = byNormalizedName.get(normalizeName(alias));
      if (hit?.imageUrl) {
        result[ourName] = toSalesbeezImageUrl(hit.imageUrl);
        break;
      }
    }
  });

  // Exact name match (e.g. Electronics)
  withImages.forEach((c) => {
    const n = normalizeName(c.name);
    Object.keys(SALESBEEZ_CATEGORY_ALIASES).forEach((ourName) => {
      if (result[ourName]) return;
      if (normalizeName(ourName) === n) {
        result[ourName] = toSalesbeezImageUrl(c.imageUrl);
      }
    });
  });

  return result;
}

export function getSalesbeezImageForCategory(categoryName, dynamicMap = {}) {
  const canonical = canonicalCategoryName(categoryName);
  if (!canonical) return null;
  return (
    dynamicMap[canonical] ||
    SALESBEEZ_STATIC_IMAGE_BY_CATEGORY[canonical] ||
    null
  );
}
